import { isEqual } from 'lodash';
import { CuDeGoodsShipmentTransformer } from './CuDeGoodsShipmentTransformer';
import { GoodsItemDetailTransformer } from './GoodsItemDetailTransformer';
import { getAllGoodsShipmentSnapshots } from './goodsShipmentFormRef';
import { getAllGoodsItemEntries } from './goodsItemFormRef';

export const hasUnsavedGoodsChanges = (): boolean => {
  const itemTransformer = new GoodsItemDetailTransformer();
  for (const { formData, original } of getAllGoodsItemEntries()) {
    if (!isEqual(formData, itemTransformer.toForm(original))) return true;
  }
  const shipmentTransformer = new CuDeGoodsShipmentTransformer();
  for (const {
    formData,
    original,
  } of getAllGoodsShipmentSnapshots().values()) {
    if (!isEqual(formData, shipmentTransformer.toForm(original))) return true;
  }
  return false;
};
